import directives from './module';
import {PlayerSvc} from '../services/PlayerSvc';
import {Utils} from '../underscore-extensions';
import {RescaleSvc} from '../services/RescaleSvc';

export class ModalVideoComponent {
    youtubeUrl: string | undefined;
    wistiaUrl: string | undefined;
    player: ng.IPromise<Player> | undefined;
    previewUrl: string;
    alt: string;
    youtubeId: string;
    wistiaId: string;
    playerUrl: string;
    playerWidth: number;
    playerHeight: number;
    onModalShown: Function = this.onModalShown || angular.noop;
    canModalShow: boolean;
    hideBorder: boolean;
    private isModalShown: boolean;

    constructor(private $element: ng.IAugmentedJQuery,
                private $sce: ng.ISCEService,
                private $timeout: ng.ITimeoutService,
                private Player: PlayerSvc) {
    }

    $onChanges() {
        this.modalShown = this.canModalShow;
    }

    $onInit() {
        if (this.youtubeId) {
            this.youtubeUrl = this.$sce.trustAsResourceUrl(`https://www.youtube.com/embed/${this.youtubeId}?autoplay=1`);
        } else if (this.wistiaId) {
            this.wistiaUrl = this.$sce.trustAsResourceUrl(`https://animatron.wistia.com/embed/iframe/${this.wistiaId}?videoFoam=true`);
        }
    }

    $onDestroy() {
        this.Player.resetPlayer(this.player);
    }

    set modalShown(shown: boolean) {
        this.isModalShown = shown;
        this.onModalShown({isModalShown: shown});

        if (shown && !this.youtubeId &&!this.wistiaId && this.playerUrl) {
            this.$timeout(() => Utils.rAF(() => {
                const maxWidth         = (window.innerWidth / 2);
                const maxHeight        = (window.innerHeight / 1.4515503875968991);
                const {width, height}  = RescaleSvc.resizeWithAspectRatio(
                    this.playerWidth, this.playerHeight, maxWidth, maxHeight, true, true
                );

                const el = this.$element[0].querySelector('.ng-modal-dialog-content');
                Object.assign(el.style, {
                    width: `${width}px`,
                    height: `${height}px`
                });

                this.player = this.Player.createPlayer(
                    this.playerUrl,
                    'player',
                    {
                        width,
                        height,
                        repeat: false,
                        autoPlay: true,
                        controlsEnabled: true
                    },
                    () => this.$element[0].querySelector('#player').style.background = ''
                );
            }));
        } else if (!shown && this.player) {
            this.$onDestroy();
        }
    }

    get modalShown() {
        return this.isModalShown;
    }
}

directives.component('modalVideo', {
    bindings: {
        previewUrl: '<?',
        alt: '<?',
        youtubeId: '<?',
        wistiaId: '<?',
        playerUrl: '<?',
        playerWidth: '<?',
        playerHeight: '<?',
        canModalShow: '<?',
        onModalShown: '&?',
        hideBorder: '<'
    },
    controller: ModalVideoComponent,
    templateUrl: require('modal-video.html')
});



// WEBPACK FOOTER //
// ./app/assets/javascripts/directives/modalVideo.ts